import React, { useMemo } from 'react';
import { Box, NavigationToggler, Option, Text } from '@common-fe/common-fe';

import { useProvideNameVisible } from '@/modules/core';

import { ElectronicStatementMessage } from '../../Statements/ElectronicStatementMessage';
import useReceiptsFeatureFlag from '../hooks/useReceiptsFeatureFlag';
import { MyDocumentsTabs, MyDocumentsTabsTitle } from '../myDocuments.types';

interface Props {
  tab: string;
  setTab: (tab: string) => void;
}

const MyDocumentsHeader: React.FC<Props> = ({ tab, setTab }) => {
  const { isReceiptsEnabled } = useReceiptsFeatureFlag();
  const isProviderNameVisible = useProvideNameVisible();

  const tabOptions = useMemo<Option[]>(() => {
    if (!isProviderNameVisible) {
      return [
        {
          key: MyDocumentsTabs.TAX_FORMS,
          value: MyDocumentsTabs.TAX_FORMS,
          title: 'Tax Forms',
        },
      ];
    }
    return [
      ...(isReceiptsEnabled
        ? [
            {
              key: MyDocumentsTabs.RECEIPTS,
              value: MyDocumentsTabs.RECEIPTS,
              title: 'Receipts',
            },
          ]
        : []),
      {
        key: MyDocumentsTabs.LMN,
        value: MyDocumentsTabs.LMN,
        title: 'Letters of Medical Necessity',
      },
      {
        key: MyDocumentsTabs.STATEMENTS,
        value: MyDocumentsTabs.STATEMENTS,
        title: 'Statements',
      },
      {
        key: MyDocumentsTabs.TAX_FORMS,
        value: MyDocumentsTabs.TAX_FORMS,
        title: 'Tax Forms',
      },
    ];
  }, [isProviderNameVisible, isReceiptsEnabled]);

  return (
    <Box direction="row" justify="between" align="center">
      <Box direction="row" align="center" gap="spacing12" flex wrap>
        <Text data-testId="my-documents-page_page-title" size="20px">
          {MyDocumentsTabsTitle?.[tab as MyDocumentsTabs]}

          {tab === MyDocumentsTabs.STATEMENTS ? <ElectronicStatementMessage /> : null}
        </Text>
      </Box>
      {!!isProviderNameVisible && (
        <NavigationToggler testId="my-documents-page" value={tab} onChange={setTab} options={tabOptions} />
      )}
    </Box>
  );
};

export default MyDocumentsHeader;
